export enum PaidStatusEnum {
    Paid = 'Paid',
    Unpaid = 'Unpaid',
    Downpayment = 'Downpayment'
}